export default __webpack_public_path__ + "static/media/avatar_alison4.778b44ba.mp3";